export default "__VITE_ASSET__CEVpLfU___"